import { OfferData } from '../../../core/domain/offerData.model'
import OfferService from '../../../core/services/offer.service'
import { LifecyclePresenter } from '../../_components/ConnectComponent'
import { AdobeEventManager } from '../../_utils/adobeAnalytics'
import { dataLayer } from '../../_utils/adobeAnalytics/adobeAnalytics.conf'
import { redirectionProvider } from '../CalculatorRedirection.provider'
import {
  PreviousInsurancesRaw,
  PreviousInsurancesValues,
  View,
} from './PreviousInsurances.view'

export class PreviousInsurancesPresenter implements LifecyclePresenter<View> {
  private view!: PreviousInsurancesRaw
  private stepPageName: string = 'previous-insurance'
  private stepPageNumber: number = 5
  protected offer: OfferData

  initialize(view) {
    this.view = view
  }

  onLifecycleStart = async () => {
    dataLayer.page.category.applicationStep = 'step5-previousInsurances'
    AdobeEventManager.track('calc_step')

    await this.getOfferDocument()

    this.view.setInitialValues(
      {
        prevDamages: Number(this.offer.numberOfClaims > 0),
        cancelledPreviousInsurance: this.offer.cancelledPreviousInsurance,
        numberOfClaims: this.offer.numberOfClaims,
        claimLoses: this.offer.claimLoses,
        years: this.offer.years,
      },
      this.offer.progressMask[6] === '1',
    )
  }

  getOfferDocument = async () => {
    try {
      this.offer = await OfferService.getOfferData()
    } catch (error) {
      console.log(error)
    }
  }

  onContinue = async (formValues: PreviousInsurancesValues) => {
    this.manageLastVisitedStep(this.stepPageNumber)

    const offer = this.setFormValues(formValues)

    OfferService.saveOfferData(offer).then(() => this.goToNextStep())
  }

  setFormValues = (formValues: PreviousInsurancesValues) => {
    const { prevDamages, ...offerValues } = formValues
    return Object.assign(this.offer, {
      ...offerValues,
    })
  }

  goToNextStep = () => {
    this.view.props.history.push(
      redirectionProvider.redirectToFollowingStep(
        this.stepPageName,
        this.offer,
      ),
    )
  }

  onBackClick = () => {
    this.view.props.history.push(
      redirectionProvider.redirectToPreviousStep(this.stepPageName, this.offer),
    )
  }

  saveAndRedirect = (formValues: PreviousInsurancesValues) => {
    this.offer = this.setFormValues(formValues)

    OfferService.saveOfferData(this.offer).then(() => {
      this.view.props.history.push('/contact-me')
    })
  }

  manageLastVisitedStep = (currentStep: number) => {
    let progress = this.offer.progressMask
    this.offer.progressMask =
      progress.substr(0, currentStep - 1) + '1' + progress.substr(currentStep)
  }
}
